import React from "react";
import Media from "react-media";

import { markdownify } from "config/utils";
import theme from "config/theme";

import Button from "components/Button";
import { Container } from "components/Grid";
import { BlockWrapper } from "components/Block";
import { KeyFeatureItem } from "components/Feature";
import { Title, Heading, Content } from "components/Block/ContentBlock/styles";

import { Inner, Image } from "./styles";

const Text = ({ content }) => {
  return (
    <BlockWrapper
      px={["10px", "20px"]}
      pt="50px"
      pb="10px"
      mb={["0", "50px"]}
      shade="light"
      overflow="hidden"
    >
      <Container alignItems="center">
        <Inner>
          {content.title && <Title>{content.title}</Title>}
          <Heading>{content.heading}</Heading>
          <Content
            dangerouslySetInnerHTML={{ __html: markdownify(content.text) }}
          />
        </Inner>
      </Container>
    </BlockWrapper>
  );
};

export default Text;
